import Setting from './Setting.vue';

export default Setting;
